import * as yup from 'yup';

const LoginSchema = yup.object().shape({
  email: yup.string().required('email Required'),
    password: yup.string().required('Password Requred')
  });

  export default LoginSchema;